import React, { useState, useEffect, Fragment } from 'react';

//import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
    Button,
    Alert,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,
} from "react-bootstrap";

import "./WordByWordUpdate.css";
import "./bubble.css";
//import logo from "./sethu.ai_1.jpg";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { ThemeProvider } from '@mui/material'
import { AppBar, Link, Toolbar, Typography } from "@mui/material";

function WordByWordUpdateYou() {
    const [item, setItems] = useState([])
    const [text, setText] = useState('Hello World');
    const [message, setMessage] = useState('');
    const [qmessage, setQMessage] = useState('light reflection explanation in optics');
    const [displayedText, setDisplayedText] = useState('');
    const [videoURL, setVideoURL] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusCode, setStatusCode] = useState(-1);

    useEffect(() => {
        const interval = setInterval(() => {
            //setLoadingText(prevText => prevText === 'Loading...' ? 'Loading' : prevText + '.');
            //if (loading === true){
            setDisplayedText(prevText => prevText.includes('Loading') ? prevText + '.' : prevText);
            //setDisplayedText(loading? prevText+ '.':prevText);
            //}
            //   setDisplayedText( loading ? 
            //     (prevText => prevText === 'Loading...' ? 'Loading' : prevText + '.'):
            //     (prevText => prevText === 'Loading...' ? 'Loading' : prevText + '')

            // );
        }, 2000);

        return () => clearInterval(interval);
    }, []);


    const addItem = (qmessage, displayedText) => {
        //const newItem = `Item ${items.length + 1}`;
        setItems(prevItems => [...prevItems, { qmessage, displayedText }]);
    };

    /*useEffect(() => {
        const updateTextWithDelay = async () => {
            const words = message.split(' ');

            for (const word of words) {
                // Simulate a delay using setTimeout
                await sleep(150); // Adjust the delay time as needed

                // Update the displayedText state word by word
                setDisplayedText((prevText) => prevText + ' ' + word);
            }
        };

        updateTextWithDelay();
    }, [text]);*/

    //useEffect(() => {
    const updateTextWithDelay = async () => {
        const words = message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        addItem("<Employee >" + qmessage, message)

    };
    const aupdateTextWithDelay = async (a_message) => {
        const words = a_message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        //addItem("<Employee >" + qmessage, "<Insurance Bot >" + a_message)
        addItem(" " + qmessage, " " + a_message)

    };

    //    updateTextWithDelay();
    //}, [text]);

    // Utility function to simulate sleep
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const handleSendMessage = () => {
        setDisplayedText("Loading");
        setStatusCode(-1);
        setLoading(true);
        setMessage("");
        //fetch("http://127.0.0.1:5000/get_response/?question=" + qmessage)
        //fetch("http://127.0.0.1:5000/openapi_get_response/?question=" + qmessage)  
        //fetch("http://127.0.0.1:5000/get_response/?question=" + qmessage)
        fetch("http://157.173.222.203:8080/you_search/?query=" + qmessage)
            .then((response) => response.json())
            .then((data) => {

                //setMessage("<Customer>" + qmessage + "[SEP]<BOT>" + data.response);
                //setMessage("<BOT>" + data.response);
                setLoading(false);
                if (data.status === 0) {
                    setVideoURL(data.response);
                    setStatus(data.status_message);
                    setStatusCode(data.status);
                    setDisplayedText(data.status_message);
                }

                else {
                    setStatus(data.status_message);
                    setStatusCode(data.status);
                    setDisplayedText(data.status_message);
                }

                //console.log(message);
                //this.setState({ message: "" });
                //updateTextWithDelay();
                ///aupdateTextWithDelay(data.response);
                //setQMessage('');
                //setMessage('');

            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });

    };
    const handleInputChange = (e) => {
        setQMessage(e.target.value);
        setDisplayedText('');
        //console.log(qmessage)
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <div className='fillOutPage property'>
                <Header />
                <Container className="px-0">
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">
                        <Card>
                            <Typography variant="h5" style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                                This LLM app Is to Ask Youtube, It searches proper youtube video and points to the precise location of the video as a high school Physics teacher
                            </Typography>
                        </Card>
                        {/* <Card>
                        <h4 style={{ textAlign: 'justify' }}>This LLM app Is to Ask Youtube, It searches proper youtube video and points to the precise location of the video as a high school Physics teacher</h4>
                    </Card> */}
                    </Row>
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">
                        <Card>
                            <div className="center1">
                                <div>
                                    <input
                                        className="resizedTextbox1"
                                        type="text"
                                        id="fname"
                                        placeholder="Type your youtube video search Here..."
                                        onChange={handleInputChange}
                                        value={qmessage}
                                        onKeyPress={handleKeyPress} // Listen for Enter key press
                                        name="fname" />
                                    <button className='bg-secondary send-btn resizedbutton' onClick={handleSendMessage}>Send</button>
                                </div>
                            </div>
                        </Card>
                        {statusCode === -1 && (
                            <Card>
                                <div class="middle_1">
                                    {/* <p class="left-align">{" " + qmessage}</p> */}

                                    <p class="left-align">{" " + displayedText}</p>
                                </div></Card>
                        )}
                        {statusCode === 0 && (
                            <Card>

                                <iframe
                                    width="auto"
                                    height="335"
                                    src={videoURL}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    title="Embedded YouTube"
                                ></iframe>

                            </Card>
                            // <div style={{ backgroundColor: 'lightgreen', padding: '10px', marginTop: '10px' }}>
                            //     Operation was successful!
                            // </div>
                        )}
                    </Row><div class="middle_0">
                        {/* <p class="left-align">{" " + qmessage}</p> */}

                        {/* <p class="left-align">{" " + displayedText}</p> */}
                    </div>


                </Container>


                {/* </main> */}
                <Footer />
            </div>
        </ThemeProvider>

    );
}

export default WordByWordUpdateYou;




